let LoadMode = /* @__PURE__ */ function(LoadMode$1) {
	LoadMode$1["dynamic"] = "dynamic";
	LoadMode$1["single"] = "single";
	LoadMode$1["double"] = "double";
	return LoadMode$1;
}({});
export { LoadMode };

//# sourceMappingURL=index49.js.map